<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? label : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [options]="statuses"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [itemStyleClass]="itemStyleClass"
  filterBy="name"
  [(selectedItems)]="selectedStatuses"
  (selectedItemsChange)="onSelectedStatusesChange($event)"
  (openedChange)="openedChange.emit($event)"></crm-multi-select>
